import { html } from 'lit';
import { customElement } from 'lit/decorators.js';

import i18n from 'portal-base/src/decorators/i18n';

import { dsViewStyles } from 'ds-shared-lib/src/base/css/ki-ds-view-styles.css';

import nls from '../../locales/indexes.nls';
import { getAlarmData } from '../../services/alarming';
import {
    fetchChannelMetaData,
    fetchLastValues,
    fetchTimeseriesMeta,
    getChannelIdFromUrl,
    groupByLocation,
} from '../../services/channel';
import { getParameters } from '../../services/parameters';
import { showToast } from '../../services/toast-service';
import KiDsPwaView from '../pwa-view/ki-ds-pwa-view';
import styles from './last-values-view.css';
import '../../components/ki-ds-pwa-timeseries-list/ki-ds-pwa-timeseries-list';

const CLASS_NAME = 'last-values-view';

@i18n(nls)
@customElement(CLASS_NAME)
class KiDsPwaLastValuesView extends KiDsPwaView {
    static styles = [...dsViewStyles, styles];

    static get properties() {
        return {
            timeseriesByLocation: { type: Object },
            alarmStatus: { type: Array },
            alarmConfigs: { type: Array },
            classificationTemplate: { type: Object },
            parameters: { type: Object },
            isLoading: { type: Boolean },
        };
    }

    constructor() {
        super();
        this.timeseriesByLocation = {};
        this.alarmStatus = [];
        this.alarmConfigs = [];
        this.classificationTemplate = null;
        this.parameters = null;
        this.isLoading = true;
    }

    async firstUpdated() {
        super.firstUpdated();
        await this._loadView();
    }

    async _loadView() {
        this.isLoading = true;
        try {
            this.channelId = getChannelIdFromUrl();

            const [parameters, channel, timeseriesMeta, lastValues] = await Promise.all([
                getParameters(),
                fetchChannelMetaData(this.channelId),
                fetchTimeseriesMeta(this.channelId),
                fetchLastValues(this.channelId),
            ]);

            this.parameters = parameters;
            this.timeseriesByLocation = groupByLocation(timeseriesMeta, lastValues);
            this._setDocumentTitle(channel);
            this._dispatchChannelLoaded(channel);

            if (channel.channelFeatures?.alarming) {
                await this._loadAlarmData();
            }
        } catch (_err) {
            showToast({ content: 'Failed to load channel data', type: 'error' });
        } finally {
            this.isLoading = false;
        }
    }

    async _loadAlarmData() {
        const alarmData = await getAlarmData(this.channelId);
        this.alarmStatus = alarmData.alarmStatus;
        this.alarmConfigs = alarmData.alarmConfigs;
        this.classificationTemplate = alarmData.classificationTemplate;
    }

    render() {
        return html`
            <div class="view">
                <ki-ds-pwa-timeseries-list
                    .timeseriesByLocation=${this.timeseriesByLocation}
                    .selectedIds=${[]}
                    .selectable=${false}
                    .alarmStatusList=${this.alarmStatus}
                    .alarmConfigs=${this.alarmConfigs}
                    .classificationTemplate=${this.classificationTemplate}
                    .parameters=${this.parameters}
                    .isLoading=${this.isLoading}
                ></ki-ds-pwa-timeseries-list>
            </div>
        `;
    }
}
